<template>
  <a
    ref="textCard"
    :href="link"
    class="card-text cursor p-2"
    :class="[align, { visible: isVisible, 'en-font': lang === 'ENG' }]"
  >
    <div class="story-card-header">
      <h3 class="card-title">{{ title }}</h3>
      <div class="arrow-btn arrow-normal">
        <b-img src="/static_img/skinc/esg_story/circle-arrow.svg" />
      </div>
      <div class="arrow-btn arrow-hover">
        <b-img src="/static_img/skinc/appendix/arrow_focus.svg" />
      </div>
    </div>
    <div class="card-desc" v-html="description"></div>
  </a>
</template>

<script>
export default {
  name: 'CardText',
  props: {
    title: { type: String, required: true },
    description: { type: String, required: true },
    align: { type: String, default: 'left' },
    link: { type: String, default: '#' },
    lang: { type: String, default: 'KOR' }
  },
  data() {
    return {
      isVisible: false,
      observer: null
    };
  },
  mounted() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.isVisible = entry.isIntersecting;
      },
      {
        threshold: 0.2
      }
    );
    this.observer.observe(this.$refs.textCard);
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
};
</script>

<style scoped>
.card-text {
  position: absolute;
  top: 50%;
  width: 100%;
  z-index: 10;
  color: #fff;
  opacity: 0;
  transition: opacity 0.8s ease 0.2s, transform 0.8s cubic-bezier(0.25, 1, 0.5, 1) 0.2s;
  text-shadow: 0px 2px 5px rgba(0, 0, 0, 0.8);
}

.card-text.left {
  left: 105%;
  transform: translateY(-50%) translateX(-40px);
}

.card-text.right {
  right: 105%;
  text-align: left;
  transform: translateY(-50%) translateX(40px);
}

.card-text.visible {
  opacity: 1;
  transform: translateY(-50%) translateX(0);
}

.story-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.card-title {
  margin: 0;
  font-weight: 600;
  font-size: clamp(1.25rem, 2vw, 2.25rem);
}

.card-desc {
  color: #eee;
  font-weight: 600 !important;
  line-height: 1.6;
  font-size: clamp(0.9rem, 2vw, 1.5rem);
}

.card-text.en-font .card-title {
  font-size: clamp(1rem, 2vw, 1.8rem);
}

.card-text.en-font .card-desc {
  font-size: clamp(0.72rem, 2vw, 1.2rem);
}

p {
  font-weight: 600 !important;
}

.arrow-btn {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  color: #fff;
  cursor: pointer;
  margin: 0 8px;
}

@media (max-width: 1200px) {
  .card-text {
    width: calc(100% + 100% * (1200px - 100vw) / 840);
  }
}

@media (max-width: 361px) {
  .card-text {
    width: 200%;
  }
}

@media (max-width: 768px) {
  .card-text {
    top: 105%;
    left: 0;
    width: 100%;
    text-align: center;
  }

  .card-text.left,
  .card-text.right {
    transform: translateY(-30px);
    text-align: center;
    left: 0;
    right: auto;
  }

  .card-text.visible {
    opacity: 1;
    transform: translateY(0);
  }

  .story-card-header {
    justify-content: center;
  }
}

a {
  text-decoration: none;
}
a:hover {
  text-decoration: none;
  background-color: #ffffff33;
  border-radius: 12px;
}
.arrow-hover {
  display: none;
}

a:hover .arrow-normal {
  display: none;
}

a:hover .arrow-hover {
  display: block;
}
</style>
